"use client";

import React from "react";
import { OpsPulseLoader } from "@/components/ui/OpsPulseLoader";

function cn(...classes: Array<string | false | undefined | null>) {
  return classes.filter(Boolean).join(" ");
}

interface PrimaryButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  type?: "button" | "submit";
}

export function PrimaryButton({
  children,
  disabled,
  loading,
  onClick,
  type = "button",
}: PrimaryButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={cn(
        "relative h-11 w-full rounded-xl",
        "bg-gradient-to-b from-emerald-400 to-emerald-600",
        "text-sm font-semibold text-slate-950",
        "shadow-[0_10px_30px_-12px_rgba(16,185,129,0.55)]",
        "transition active:translate-y-[1px]",
        (disabled || loading) && "opacity-60 cursor-not-allowed"
      )}
    >
      <span className={cn("flex items-center justify-center gap-2", loading && "opacity-0")}>
        {children}
      </span>
      {loading ? (
        <span className="absolute inset-0 flex items-center justify-center">
          <OpsPulseLoader size={16} subtle />
        </span>
      ) : null}
    </button>
  );
}

